import { GalleryView } from './GalleryView';
import { RawFileGalleryItem } from './RawFileGalleryItem';

type RawFileGalleryProps = {
  channelGuid: string;
  standalone?: boolean;
};

export const RawFileGallery = (props: RawFileGalleryProps) => {
  const { channelGuid, standalone } = props;
  return (
    <GalleryView
      channelGuid={channelGuid}
      fileUploadType='RAW'
      columnQuery={{
        sm: [800, 1],
        md: [1000, 1],
        lg: [1200, standalone ? 1 : 2],
        xl: [1500, standalone ? 1 : 3],
      }}
      itemBuilder={(message) => (
        <RawFileGalleryItem key={message.guid} message={message} />
      )}
      gap={20}
    />
  );
};
